import React, {useCallback} from 'react';
import Form from '../../components/form/Form'
import {extendedInfoForm} from '../../formDefinitions/ExtendedInfo/ExtendedInfoForm'
import {useSelector} from 'react-redux'
import {apphistory, AppState} from '../../store'
import {AllAdditionalFieldsNames, AllBasedFieldsNames, FormNames} from '../../models/form/IFormDefinition'
import useFormLogic from '../../components/form/hooks/useFormLogic'
import {TFieldValuesObject} from '../../components/form/FormProps'
import PageScreen from "../../components/organisms/Page/PageScreen";
import LoanOfferSummaryPanel from '../../components/organisms/LoanOfferSummaryPanel/LoanOfferSummaryPanel'

const ExtendedInfoForm = () => {
    const extendedInfoState = useSelector((state: AppState) => state.formState[FormNames.ExtendedInfoForm])
    const {handleValidateForm} = useFormLogic()

    const handleOnExtendedInfoFormSubmit = useCallback((fieldValuesObject: TFieldValuesObject<Partial<typeof AllBasedFieldsNames>> | TFieldValuesObject<Partial<typeof AllAdditionalFieldsNames>>) => {
        const result = handleValidateForm({
            formName: extendedInfoForm.name,
            fieldValuesObject,
            formValidationFunctionsObject: extendedInfoForm.formValidationFunctions
        })
        result && extendedInfoForm.nextFormUrlPath && apphistory.push(extendedInfoForm.nextFormUrlPath)
    }, [handleValidateForm])


    return (
        <PageScreen
            title={{title: "Twoje dane", line: true}}
            panel={<LoanOfferSummaryPanel loanVariant="predefined" />}
            showBackButton={false}
        >
            <Form
                fields={extendedInfoForm.fields}
                form={extendedInfoForm}
                formState={extendedInfoState}
                onFormSubmit={handleOnExtendedInfoFormSubmit}
            />
        </PageScreen>
    )
}

export default ExtendedInfoForm